module.exports = __webpack_public_path__ + "bug-labs.svg";